import http from "services/http";

// Interface for booking stats request payload
export interface IBookingStatsRequest {
  email: string;
  from: string; // Date in YYYY-MM-DD format
  to: string; // Date in YYYY-MM-DD format
}

/**
 * Send booking statistics to an email address
 * @param data The request payload containing email and date range
 * @returns Promise with the response data
 */
export const sendBookingStats = async (
  data: IBookingStatsRequest
): Promise<any> => {
  const res = await http.post("/admin/email/bookingStats", data);
  return res.data;
};

/**
 * Get booking statistics for a date range
 * @param data The request payload containing date range
 * @returns Promise with the response data
 */
export const getBookingStats = async (
  page: number = 1,
  limit: number = 10
): Promise<any> => {
  const res = await http.get(
    `/admin/dashboard/flight?page=${page}&limit=${limit}`
  );
  return res.data;
};

/**
 * Get flight dashboard data by ID
 * @param id The flight ID
 * @returns Promise with the response data
 */
export const getFlightDashboard = async (id: string): Promise<any> => {
  const res = await http.get(`/admin/dashboard/flight/${id}`);
  return res.data;
};
